function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M7 2.05v19.9c-3.15-.29-5-2.4-5-5.76V7.81c0-3.36 1.85-5.47 5-5.76z"
}), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M22 7.81v8.38c0 3.64-2.17 5.81-5.81 5.81H7.81c-.28 0-.55-.01-.81-.05V2.05c.26-.04.53-.05.81-.05h8.38C19.83 2 22 4.17 22 7.81z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.49 6.8c-.32-.25-.9-.49-1.82-.24l-2.98.82c-.89.23-1.47.98-1.47 1.92v3.91c-.23-.08-.48-.14-.74-.14-1.24 0-2.24 1.01-2.24 2.24a2.25 2.25 0 002.24 2.24c1.22 0 2.22-.99 2.24-2.2 0-.01.01-.02.01-.03v-3.7l3.97-1.08v1.68c-.23-.08-.48-.14-.75-.14-1.24 0-2.24 1.01-2.24 2.24 0 1.24 1.01 2.24 2.24 2.24 1.22 0 2.22-.99 2.24-2.21 0-.01.01-.02.01-.04V8.48c-.02-.76-.25-1.32-.71-1.68zm-7.02 9.25c-.41 0-.74-.33-.74-.74s.33-.74.74-.74.74.33.74.74-.34.74-.74.74zm5.46-1c-.41 0-.74-.33-.74-.74s.33-.74.74-.74.74.33.74.74-.33.74-.74.74z"
})));